// extracted by mini-css-extract-plugin
export var userInformationSectionHeader = "user-information-section__header_gnrgiH5ZLeo9GsPJR05Y";
export var userInformationSectionHeaderIcon = "user-information-section__header-icon_KXUj2NsqinfVd7u86dMK";
export var userInformationSectionUserState = "user-information-section__user-state_FQzWTkA235FzUcNQ2Yl0";
export var userInformationSectionUserStateActive = "user-information-section__user-state_active_OECILs4lSKm98B1LyKPd";